import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { rememberPrevPath, snapshotIntent } from "@/lib/intent";

/** Renders nothing. Remembers the page before /auth, and freezes "what brought this person to sign up" when /auth opens (lib/intent.js). */
export default function IntentWatcher() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (pathname === "/auth") snapshotIntent();
    else rememberPrevPath(pathname + search);
  }, [pathname, search]);
  return null;
}
